import DetailJobOrder from './DetailJobOrder';

export default DetailJobOrder;
